import { NumberFilterOperation } from "abweb/dto/generated/inputargs/NumberFilterOperation";
import { NumberFilterValueBase } from "abweb/dto/generated/inputargs/NumberFilterValueBase";
export class NumberFilterValue extends NumberFilterValueBase {
  static createNumberFilterValue(firstValue, isOpNegated, op, secondValue) {
    const retVal = new NumberFilterValue();
    retVal.initNumberFilterValue(null, firstValue, isOpNegated, op, secondValue);
    return retVal;
  }
  constructor() {
    super();
    this.initNumberFilterValue(null, null, false, NumberFilterOperation.GreaterThan, null);
  }
  clone() {
    return NumberFilterValue.createNumberFilterValue(this.firstValue, this.isOpNegated, this.op, this.secondValue);
  }
  static convertNulltoNaN(value) {
    return value == null ? NaN : value;
  }
  static convertNaNToNull(value) {
    return Number.isNaN(value) ? null : value;
  }

  // To be consistent with previous NumberFilterValue, firstValue and secondValue have NaN if not specified

  get firstValue() {
    return NumberFilterValue.convertNulltoNaN(super.firstValue);
  }
  set firstValue(value) {
    super.firstValue = NumberFilterValue.convertNaNToNull(value);
  }
  get secondValue() {
    return NumberFilterValue.convertNulltoNaN(super.secondValue);
  }
  set secondValue(value) {
    super.secondValue = NumberFilterValue.convertNaNToNull(value);
  }
}
//# sourceMappingURL=NumberFilterValue.js.map
